export default "__VITE_ASSET__B3Icp9x2__"